const configNode = document.querySelector('[data-lead-magnet-config]');

if (configNode) {
	const widgetSubmitUrl = configNode.dataset.widgetSubmitUrl;
	const dismissUrl = configNode.dataset.dismissUrl;
	const defaultTag = configNode.dataset.defaultTag;

	const bindGdprGate = (form) => {
		if (!form) return;
		const gdpr = form.querySelector('[name="gdpr"]');
		const submit = form.querySelector('[type="submit"]');
		if (!gdpr || !submit) return;
		const sync = () => {
			submit.disabled = !gdpr.checked;
			submit.classList.toggle('disabled', !gdpr.checked);
		};
		gdpr.addEventListener('change', sync);
		sync();
	};

	const dismissLead = (tag) => {
		const url = new URL(dismissUrl, window.location.origin);
		url.searchParams.set('tag', tag);
		fetch(url.toString(), {
			method: 'POST',
			headers: {'X-Requested-With': 'XMLHttpRequest'},
			credentials: 'same-origin',
			keepalive: true,
		}).catch(() => {});
	};

	// --- Popup (single instance, rendered even when dismissed so widgets can share the page context) ---
	const popup = document.getElementById('fn_pu');

	if (popup && !popup.hasAttribute('hidden')) {
		let timer = null;

		const onScroll = () => {
			const scrollPosition = window.scrollY + window.innerHeight;
			const oneThird = document.documentElement.scrollHeight / 3;
			if (scrollPosition >= oneThird) {
				showPopup();
			}
		};

		const cleanup = () => {
			clearTimeout(timer);
			window.removeEventListener('scroll', onScroll);
		};

		const showPopup = () => {
			cleanup();
			popup.classList.add('c_pu--visible');
		};

		timer = setTimeout(showPopup, 15000);
		window.addEventListener('scroll', onScroll, {passive: true});

		const btn = document.getElementById('fn_pu-btn');
		if (btn) {
			btn.addEventListener('click', () => {
				const btnContainer = document.getElementById('fn_pu-btn-container');
				const form = document.getElementById('fn_pu-form');
				if (!btnContainer || !form) return;
				btnContainer.classList.add('c_pu__content-btn--hidden');
				btnContainer.addEventListener('animationend', () => {
					btnContainer.style.display = 'none';
					form.classList.add('c_pu__content-form--visible');
				}, {once: true});
			});
		}

		bindGdprGate(document.getElementById('fn_pu-form'));

		const closeBtn = document.getElementById('fn_pu-close');
		if (closeBtn) {
			closeBtn.addEventListener('click', () => {
				cleanup();
				const tag = popup.dataset.tag || defaultTag;
				dismissLead(tag);
				popup.classList.add('c_pu--hidden');
				popup.addEventListener('animationend', () => {
					popup.remove();
				}, {once: true});
			});
		}
	}

	// --- Inline widgets (may appear multiple times per article) ---
	const hydrateWidgets = () => {
		document.querySelectorAll('[data-lead-magnet-widget]:not([data-lead-magnet-widget-ready])').forEach((widget, index) => {
			widget.setAttribute('data-lead-magnet-widget-ready', '');

			const tag = widget.dataset.tag || defaultTag;
			const title = widget.dataset.title || 'Je váš web připravený pro AI asistenty?';
			const description = widget.dataset.description || 'Stáhněte si praktický checklist';
			const button = widget.dataset.button || 'Chci získat náskok';
			const image = widget.dataset.image || '';
			const imageAlt = widget.dataset.imageAlt || title;
			const gdprLabel = widget.dataset.gdprLabel || 'Souhlasím se zpracováním osobních údajů';
			const successMessage = widget.dataset.successMessage || 'Díky, checklist je na cestě do vaší schránky';

			const checkboxId = `fn_lmw-gdpr-${index}`;
			widget.innerHTML = `
				<div class="c_pu__content">
					<p class="fs-4 c_pu__content-headline"></p>
					<p class="c_pu__content-text"></p>
					<form class="c_pu__content-form" data-lead-magnet-widget-form novalidate>
						<fieldset>
							<div class="input-group mb-2">
								<input type="email" name="email" class="form-control" placeholder="vas@email.cz" autocomplete="email" required>
								<button type="submit" class="btn btn-primary" data-button></button>
							</div>
							<div class="form-check mb-sm-0">
								<input class="form-check-input" type="checkbox" id="${checkboxId}" name="gdpr" value="1" required>
								<label class="form-check-label" for="${checkboxId}" data-gdpr-label></label>
							</div>
							<input type="hidden" name="tag">
						</fieldset>
					</form>
					<div class="c_pu__content-error alert alert-danger mt-2" data-widget-error role="alert" hidden></div>
					<div class="c_pu__content-success" hidden></div>
				</div>
			`;
			if (image) {
				const imgWrapper = document.createElement('div');
				imgWrapper.className = 'c_pu__img';
				const img = document.createElement('img');
				img.src = image;
				img.alt = imageAlt;
				img.width = 181;
				img.height = 220;
				imgWrapper.appendChild(img);
				widget.appendChild(imgWrapper);
			}
			widget.querySelector('[name="tag"]').value = tag;

			widget.querySelector('.c_pu__content-headline').textContent = title;
			widget.querySelector('.c_pu__content-text').textContent = description;
			widget.querySelector('[data-button]').textContent = button;
			widget.querySelector('[data-gdpr-label]').textContent = gdprLabel;
			widget.querySelector('.c_pu__content-success').textContent = successMessage;

			const errorNode = widget.querySelector('[data-widget-error]');
			const showError = (message) => {
				errorNode.textContent = message;
				errorNode.hidden = false;
			};
			const clearError = () => {
				errorNode.hidden = true;
				errorNode.textContent = '';
			};

			const form = widget.querySelector('[data-lead-magnet-widget-form]');
			bindGdprGate(form);

			const triggerRecaptchaLoad = () => {
				if (window.vhRecaptcha && typeof window.vhRecaptcha.ensureLoaded === 'function') {
					window.vhRecaptcha.ensureLoaded();
				}
			};
			form.addEventListener('focusin', triggerRecaptchaLoad, { once: true });
			form.addEventListener('pointerdown', triggerRecaptchaLoad, { once: true });

			form.addEventListener('submit', async (event) => {
				event.preventDefault();
				clearError();

				const email = form.querySelector('[name="email"]').value.trim();
				const gdpr = form.querySelector('[name="gdpr"]').checked;
				const formTag = form.querySelector('[name="tag"]').value || tag;

				if (!email || !gdpr) {
					showError('Vyplňte prosím e-mail a souhlas se zpracováním osobních údajů.');
					return;
				}

				if (window.vhRecaptcha && typeof window.vhRecaptcha.ensureLoaded === 'function') {
					await window.vhRecaptcha.ensureLoaded().catch(() => {});
				}

				const token = await new Promise((resolve) => {
					if (!window.grecaptcha || typeof window.grecaptcha.execute !== 'function') {
						resolve('');
						return;
					}
					window.grecaptcha.ready(() => {
						window.grecaptcha.execute().then(resolve).catch(() => resolve(''));
					});
				});

				if (!token) {
					showError('Ověření proti botům se nepodařilo načíst. Obnovte prosím stránku a zkuste to znovu.');
					return;
				}

				const body = new FormData();
				body.append('tag', formTag);
				body.append('email', email);
				body.append('gdpr', '1');
				body.append('g-recaptcha-response', token);

				const response = await fetch(widgetSubmitUrl, {
					method: 'POST',
					body: body,
					headers: {'X-Requested-With': 'XMLHttpRequest'},
					credentials: 'same-origin',
				}).catch(() => null);

				const data = response && response.ok ? await response.json().catch(() => null) : null;
				if (!data || data.success !== true) {
					const reason = data && data.error === 'recaptcha'
						? 'Ověření proti botům selhalo, zkuste to prosím znovu.'
						: 'Odeslání se nezdařilo, zkuste to prosím znovu.';
					showError(reason);
					return;
				}

				form.style.display = 'none';
				widget.classList.add('c_pu--submitted');
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({'event': 'leadMagnetSent'});
				const success = widget.querySelector('.c_pu__content-success');
				if (success) {
					success.hidden = false;
				}
			});
		});
	};

	hydrateWidgets();
	document.addEventListener('DOMContentRefreshed', hydrateWidgets);
}
